import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RevisionIdSchema } from "../primitives/ids.js";
import { QualityGateStatusSchema } from "./quality-gate-result.js";
import { ReportCoverageSummaryV1Schema } from "./report-check-summary.js";
import { Phase1CheckStatusSchema } from "./phase1-check-result.js";
export const LaunchProofAggregateStatusSchema = z.enum([
    "ready",
    "ready_with_warnings",
    "blocked",
    "not_evaluated",
]);
export const LaunchProofPhase1SectionV1Schema = z
    .object({
    schemaVersion: z.literal("launch-proof-phase1-section.v1.0"),
    checkId: z.string().min(1),
    areaLabel: z.string().min(1),
    status: Phase1CheckStatusSchema,
    clientSafeSummary: z.string().min(1),
    internalSummary: z.string().min(1).optional(),
})
    .strict();
export const LaunchProofSearchReadinessExcerptV1Schema = z
    .object({
    schemaVersion: z.literal("launch-proof-search-readiness-excerpt.v1.0"),
    headline: z.string().min(1),
    qaStatus: QualityGateStatusSchema,
    coverage: ReportCoverageSummaryV1Schema,
    staleBanner: z.string().min(1).nullable(),
})
    .strict();
/** launch-proof-report.v1.0 — composed Launch Proof document (not persisted in Phase 2). */
export const LaunchProofReportV1Schema = z
    .object({
    schemaVersion: z.literal("launch-proof-report.v1.0"),
    proofId: z.string().min(1),
    agencyId: AgencyIdSchema.optional(),
    projectId: ProjectIdSchema.optional(),
    proofReferenceLabel: z.string().min(1),
    aggregateStatus: LaunchProofAggregateStatusSchema,
    headline: z.string().min(1),
    phase1Sections: z.array(LaunchProofPhase1SectionV1Schema).min(1),
    searchReadinessExcerpt: LaunchProofSearchReadinessExcerptV1Schema.optional(),
    departureKitSummary: z.string().min(1).optional(),
    qualityGateStatus: QualityGateStatusSchema.optional(),
    managerExceptions: z.array(z.string().min(1)).optional(),
    skippedChecks: z.array(z.string().min(1)).optional(),
    clientMissingInfo: z.array(z.string().min(1)).optional(),
    whatWeDoNotPromise: z.array(z.string().min(1)).min(1),
    launchProofDisclaimers: z.array(z.string().min(1)).min(1),
    businessGraphRevisionId: RevisionIdSchema.optional(),
    artifactSetHash: z.string().min(1).optional(),
    generatedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=launch-proof-report.js.map